import * as React from 'react';
import './style/list-item.less';
import { DiffStatesClass } from '@interface/index';

export const defaultItem = (
  item: any,
  index: number,
  itemContent: (item: any, index: number) => React.ReactNode,
  itemPrefix?: (item: any, index: number) => React.ReactNode,
  itemSuffix?: (item: any, index: number) => React.ReactNode
): React.ReactNode => {
  let versionStyle = '';
  if (item && item.state) {
    versionStyle = DiffStatesClass[item.state];
  }

  return (
    <div
      className={`list-item ${versionStyle}`}
      key={`item-${index}`}
      style={index === 0 ? { borderTop: 'none' } : {}}
      onClick={(e: any) => {
        e.stopPropagation();
      }}
    >
      {itemPrefix && (
        <div className="item__prefix-box">{itemPrefix(item, index)}</div>
      )}

      <div className="item__content">{itemContent(item, index)}</div>

      {itemSuffix && (
        <div className="item__suffix-box">{itemSuffix(item, index)}</div>
      )}

    </div>
  );
};
